import { createStoreProvider } from '@konova/ui/create-store-provider';
import { createContext, useContext } from 'react';
import { createStore, useStore } from 'zustand';

export type ErrorStoreState = {
  open: boolean;
  title: string | null;
  description: string | null;
  show: (title: string, description: string) => void;
  close: () => void;
};

const errorStore = () =>
  createStore<ErrorStoreState>(set => ({
    open: false,
    title: null,
    description: null,
    show: (title, description) => set({ open: true, title, description }),
    close: () => set({ open: false, title: null, description: null }),
  }));

const ErrorStoreContext = createContext(errorStore());

export const ErrorStoreProvider = createStoreProvider(ErrorStoreContext, errorStore);

export const useErrorStore = () => {
  const context = useContext(ErrorStoreContext);
  return useStore(context, state => state);
};